import { formatTypes } from '@zipari/shared-ds-util-format';

export class PrintConfig {
  fileName!: string;
  type!: string;
  zip_pdf_main_html!: string;
  zip_pdf_main_css!: string;
  static_values!: string;
  zip_pdf_support_files!: string;
  endpoint!: string;
  dateFormat?: {
    format: formatTypes;
    formatOptions?: {
      originalTimezone?: string;
      timezone?: string;
    };
  };

  constructor(options: Record<string, unknown>) {
    Object.assign(this, options);
  }
}
